import isNil from 'lodash/isNil';
import omitBy from 'lodash/omitBy';

import * as D from './deps';

export function playbackPaused(async = true) {
  return D.Api.apiRequest({
    endpoint: D.Constants.Api.ApiEndpoints.PLAYBACK_PAUSED,
    content: {
      sync: !async,
    },
  });
}

export function updateStation({ stationId, name, description, enableArtistMessages }) {
  return D.Api.apiRequest({
    endpoint: D.Constants.Api.ApiEndpoints.UPDATE_STATION,
    content: { stationId, name, description, enableArtistMessages },
    actionParams: {
      updateEntitiesWith: {
        [stationId]: omitBy(
          {
            name,
            description,
            isArtistMessagesEnabled: enableArtistMessages,
          },
          isNil,
        ),
      },
    },
  });
}

export function updateStationGraphQL({ stationId, name, description, enableArtistMessages }) {
  const actionParams = {
    updateEntitiesWith: {
      [stationId]: omitBy(
        {
          name,
          description,
          isArtistMessagesEnabled: enableArtistMessages,
        },
        isNil,
      ),
    },
  };
  const requestParams = D.GraphQL.Mutations.updateStationDetails(
    {
      stationId,
      name,
      description,
      enableArtistMessages,
    },
    actionParams,
  );

  return D.Services.GraphQL.graphQLRequest(requestParams)();
}

export function playbackResumed(forceActive = false) {
  return D.Api.apiRequest({
    endpoint: D.Constants.Api.ApiEndpoints.PLAYBACK_RESUMED,
    content: {
      forceActive,
    },
  });
}

export function trackStarted({ trackToken, syncToken, originalStationId }) {
  return D.Api.apiRequest({
    endpoint: D.Constants.Api.ApiEndpoints.TRACK_STARTED,
    content: {
      trackToken,
      syncToken,
      originalStationId,
    },
  });
}

export default {
  playbackPaused,
  updateStation,
  playbackResumed,
  trackStarted,
};
